import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import useThemeDetails from './theme-details.hook';
import ThemeForm from './components/theme-form';
import { Stack } from '@mui/system';
import ProductsListByTheme from './components/products-list-by-theme';

export default function ThemeDetails() {
  const {
    isEdit,
    loadingThemeDetails,
    methods,
    onSubmit,
    isSubmitting,
    MULTIPLE_LABEL,
    MULTIPLE_OPTIONS,
    values,
  } = useThemeDetails();
  return (
    <Page title={isEdit ? 'Editar Tema' : 'Cadastrar Tema'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={isEdit ? 'Editar Tema' : 'Cadastrar Tema'}
          links={[]}
          sx={{ mb: 3 }}
        />
        {loadingThemeDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <Stack spacing={2}>
            <ThemeForm
              methods={methods}
              onSubmit={onSubmit}
              isEdit={isEdit}
              isSubmitting={isSubmitting}
              multipleOptions={MULTIPLE_OPTIONS}
              multipleLabel={MULTIPLE_LABEL}
              values={values}
            />
            {isEdit && <ProductsListByTheme fixedFilter="theme" />}
          </Stack>
        )}
      </Container>
    </Page>
  );
}
